import { Box } from "../mantine-passthroughs/index.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/container/ContainerItem.tsx
const ContainerItem = ({ children, className, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Box, {
		className,
		"data-testid": testId,
		children
	});
};

//#endregion
export { ContainerItem };